import { useContext, useMemo } from 'react'

import { Button, getCurrentBaseUrl } from '@hhgtech/hhg-components'
import { redirectToSSOWithReturnUrl } from 'api/utils'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { TogetherPostV2 } from 'interfaces/types'
import { useIntl } from 'react-intl'
import { AppContext } from 'state/appContext'

// import { CardPostContent } from '../embededCommunity/postContent'
import { Post } from './components/post'
import { StyledPostSection } from './index.styled'

type PostSectionProps = {
  posts?: TogetherPostV2[]
  isJoined?: boolean
  communitySlug?: string
}

export const PostSection = ({
  posts,
  isJoined,
  communitySlug,
}: PostSectionProps) => {
  const {
    state: { isLoggedIn },
  } = useContext(AppContext)
  const { locale } = useRouterExtend()
  if (!posts) return null

  const { formatMessage: f } = useIntl()
  const showJoinCommunity = useMemo(() => !isLoggedIn || !isJoined, [
    isLoggedIn,
    isJoined,
  ])

  const joinDiscussion = () => {
    window.open(
      `${getCurrentBaseUrl(locale, true)}/community/${communitySlug}`,
      '_blank',
    )
  }

  const joinCommunity = () => {
    redirectToSSOWithReturnUrl(
      `${getCurrentBaseUrl(
        locale,
        true,
      )}/community/on-boarding/?returnUrl=/${communitySlug}`,
      'communities',
      communitySlug,
    )
  }

  return (
    <StyledPostSection>
      {posts?.length
        ? posts.slice(0, 3).map((post, index) => (
            <>
              <Post key={post.id} post={post} communitySlug={communitySlug} />
              {index !== 2 && <hr />}
            </>
          ))
        : null}

      {showJoinCommunity ? (
        <Button
          theme="marryBaby"
          color="secondary"
          isBlock
          size="lg"
          onClick={joinCommunity}
          className="join pointer-event-child-none"
          data-event-category="Together"
          data-event-action="Embedded Join Community"
          data-event-label={`${getCurrentBaseUrl(
            locale,
            true,
          )}/community/${communitySlug}`}
        >
          {f({
            id: 'together.embed.topicCard.joinNow',
            defaultMessage: 'Join Community',
          })}
        </Button>
      ) : (
        <Button
          theme="marryBaby"
          color="secondary"
          isBlock
          size="lg"
          onClick={joinDiscussion}
          className="join pointer-event-child-none"
          data-event-category="Together"
          data-event-action="Embedded Join Discussion"
          data-event-label={`${getCurrentBaseUrl(
            locale,
            true,
          )}/community/${communitySlug}`}
        >
          {f({
            id: 'together.embed.topicCard.joinDiscussion',
            defaultMessage: 'Join Discussion',
          })}
        </Button>
      )}
    </StyledPostSection>
  )
}
